import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.accountDepartmentList.loading;
export const selectErrorMessage = (state: RootState) =>
  state.accountDepartmentList.error;
export const departmentListDataResponse = (state: RootState) =>
  state.accountDepartmentList.departmentListResponse;
